import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { IoIosShareAlt } from 'react-icons/io';
import API_URL from '../../config';
import MarkdownWithCodeBlock from './Markdown';
import Views from './Views';

const PageContainer = styled.div`
  background-color: #eee;
  min-height: 90vh;
  padding: 3rem;
  margin-top: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  @media(max-width: 768px) {
    padding: 0;
  }
`;

const BlogContainer = styled.div`
  position: relative;
  background-color: #f9f9f9;
  border-radius: 7px;
  padding: 0 20px 20px 20px;
  width: 90%;
  max-width: 900px;
  @media(max-width: 800px) {
    width: 100%;
    padding: 0;
  }
`;

const BlogTitle = styled.h2`
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
`;

const BlogContent = styled.div`
  font-size: 16px;
  color: #777;
  margin-bottom: 50px;
  padding: 3rem;
`;

const BlogDate = styled.div`
  /* font-family: 'Courier New', Courier, monospace; */
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #999;
  margin: 0 0 30px 5rem;
  @media(max-width: 768px) {
    margin: 0 0 30px 3rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 40px);
  padding: 20px;
  z-index: 999;
  @media(max-width: 768px) {
    padding: 0;
  }
`;

const ShareButton = styled.button`
  background-color: transparent;
  color: #007bff;
  border: none;
  border-radius: 5px;
  padding: 10px 16px;
  cursor: pointer;
  transition: color 0.3s ease;
  &:focus {
    outline: none;
  }
  &:hover {
    color: #0056b3;
  }
`;

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ''; // Handle invalid date
  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };
  return date.toLocaleString('en-In', options);
};

const BlogDetailPage = () => {
  const { id } = useParams();
  const [blogData, setBlogData] = useState({});

  useEffect(() => {
    fetchBlogDetails();
  }, []);

  const fetchBlogDetails = () => {
    fetch(`${API_URL}/blog/${encodeURIComponent(id)}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setBlogData(data);
      })
      .catch(error => {
        console.error('Error fetching blog details:', error);
      });
  };

  const handleShare = () => {
    const blogUrl = `${window.location.origin}/blog/${id}`;
    if (navigator.share) {
      navigator.share({
        title: 'Check out this blog post!',
        text: 'Read this interesting blog post',
        url: blogUrl,
      })
        .then(() => console.log('Blog shared successfully'))
        .catch((error) => console.error('Share failed:', error));
    } else {
      alert(`Share blog ${id} at: ${blogUrl}`);
    }
  };

  return (
    <PageContainer>
      <BlogContainer>
        <BlogContent>
          <MarkdownWithCodeBlock
            content={blogData.content}
          />
        </BlogContent>
        <BlogDate>{formatDate(blogData.createdAt)}</BlogDate>
        <ButtonContainer>
          <Views>{blogData.views}</Views>
          <ShareButton onClick={handleShare}>
            <IoIosShareAlt size={24} />
          </ShareButton>
        </ButtonContainer>
      </BlogContainer>
    </PageContainer>
  );
};

export default BlogDetailPage;
